export default __webpack_public_path__ + "static/media/roles.16bee2e2.svg";